module.exports = __webpack_public_path__ + "c6add564355e555a6245d8a86cf0b4bf.csv";